import PatternRegex from '@/data/usecases/data-format-pattern/pattern-regex'
import { formatCnpj } from '@/data/usecases/data-format-pattern/cnpj'
import { Locale } from '@/domain/models/locale'
import Decimal from 'decimal.js-light'

export const formatNumber = (number: number) => (number ?? 0).toLocaleString('pt-BR')

export const formatMoney = (
  value?: number,
  addPrefix: boolean = true,
  locale: Locale.Enum = Locale.Enum.BR
) => {
  return addPrefix
    ? (value ?? 0).toLocaleString(locale.value, {
        style: 'currency',
        currency: locale.currency,
        minimumFractionDigits: 2
      })
    : (value ?? 0).toLocaleString(locale.value, { minimumFractionDigits: 2 })
}

export const convertStringToDecimal = (value: string): Decimal => {
  const cents = PatternRegex.getOnlyNumbers(value)
  return new Decimal(cents).div(100)
}

const calculatePercentage = (totalValue: Decimal, percentage: number): Decimal => {
  const coParticipationValue = new Decimal(percentage).div(100)
  return totalValue.mul(coParticipationValue)
}

export const calculateCreditsValue = (
  value: string,
  coParticipation: number,
  balance: number
): string => {
  const totalValue = convertStringToDecimal(value)
  const coParticipationValue = calculatePercentage(totalValue, 100 - coParticipation)
  const balanceValue = new Decimal(balance)
  let creditsValue = coParticipationValue.greaterThan(balanceValue)
    ? balanceValue
    : coParticipationValue
  creditsValue = creditsValue.toDecimalPlaces(2, Decimal.ROUND_HALF_EVEN)

  return formatMoney(creditsValue.toNumber())
}

// Mantém o nome exportado por compatibilidade; a lógica vive no módulo único de CNPJ
// (suporta alfanumérico AA.AAA.AAA/AAAA-00 e numérico legado).
export const formatCNPJ = formatCnpj

export const booleanToValidString = (value?: boolean | null) => {
  return typeof value === 'boolean' ? (value ? 'true' : 'false') : undefined
}

export const toBoolean = (value?: string | null) => {
  return value === 'true'
}
